export default __webpack_public_path__ + "static/media/events_1.a3fb510e.svg";